import express from '@/data/express'

/* const factory = (value, source) => {
  return (value !== undefined && source.find(c => +c.key === +value) && source.find(c => +c.key === +value).value) || value
} */

export const dataDeal = {
  expressCompany: (value) => {
    return (value && express.find(c => c.code === value) && express.find(d => d.code === value).name) || value
  }
}



// WEBPACK FOOTER //
// ./src/utils/data.js